/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerSegmentsSimpleSearchQueryResponse, PntSegmentsControllerSegmentsSimpleSearchPathParams, PntSegmentsControllerSegmentsSimpleSearchQueryParams } from "../models/PntSegmentsControllerSegmentsSimpleSearch";

export function getPntSegmentsControllerSegmentsSimpleSearchUrl(slug: PntSegmentsControllerSegmentsSimpleSearchPathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/simple-search` as const }
  return res
}

/**
 * @summary Search the segments's transciptions for the given terms in the given date range using the elastic's `simple_query_string` query.
 * {@link /pnt/v2/segments/:slug/simple-search}
 */
export async function pntSegmentsControllerSegmentsSimpleSearch(slug: PntSegmentsControllerSegmentsSimpleSearchPathParams["slug"], params: PntSegmentsControllerSegmentsSimpleSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerSegmentsSimpleSearchQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerSegmentsSimpleSearchUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}